import './App.css';
import ResponsiveAppBar from './components/Nav';
import Home from './components/Home';
import Footer from './components/Footer';
import LegalNotice from './components/LegalNotice';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import Races from './components/Races';
import RaceDetail from './components/RaceDetail';
import Login from './components/Login'
import Signup from './components/Signup';
import RegisterClub from './components/RegisterClub';
import FindClub from './components/FindClub';
import Welcome from './components/Welcome';
import Activities from './components/Activities';
import ActivitiesBar from './components/ActivitiesBar';
import Administration from './components/Administration';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import ImpersonationBanner from './components/ImpersonationBanner';
import History from './components/History';
import Events from './components/Events';
import Profile from './components/Profile';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { themeOptions } from "./assets/css/theme"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR, enUS } from '@mui/material/locale';
import { ProtectedRoute } from './routes/protectedRoutes';
import { SuperAdminRoute } from './routes/superAdminRoute';
import { useAppSelector } from './app/hooks';

// Races is browsable both as a public marketing page (no login) and from
// within the logged-in app (ActivitiesBar's "Races" link) -- unlike the
// other authenticated pages, it isn't behind ProtectedRoute, so the choice
// of navbar has to follow auth state at render time instead of the route.
function RacesNav() {
  const token = useAppSelector((state) => state.auth.token);
  return token ? <ActivitiesBar/> : <ResponsiveAppBar/>;
}

function App() {
  const { i18n } = useTranslation();
  // MUI core components (TablePagination, etc.) have their own built-in
  // English strings -- createTheme(options, locale) is the mechanism that
  // translates those, separate from react-i18next's own t() calls.
  const theme = useMemo(
    () => createTheme(themeOptions, i18n.language === 'en' ? enUS : frFR),
    [i18n.language]
  );

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <div className="App">
          <ImpersonationBanner/>
          <Routes>
            <Route path="/" element={<><ResponsiveAppBar/><Home/><Footer/></>}/>
            <Route path="/mentions-legales" element={<><ResponsiveAppBar/><LegalNotice/><Footer/></>}/>
            <Route path="/confidentialite" element={<><ResponsiveAppBar/><PrivacyPolicy/><Footer/></>}/>
            <Route path="/cgu" element={<><ResponsiveAppBar/><TermsOfUse/><Footer/></>}/>
            <Route path="/races" element={<><RacesNav/><Races/></>} />
            <Route path="/races/:id" element={<><RacesNav/><RaceDetail/></>} />
            <Route path='/login' element={<Login/>}/>
            <Route path='/signup' element={<Signup/>}/>
            <Route path='/register-club' element={<><ResponsiveAppBar/><RegisterClub/><Footer/></>}/>
            <Route path='/clubs' element={<><ResponsiveAppBar/><FindClub/></>}/>
            <Route path='/welcome' element={<ProtectedRoute/>}>
              <Route index element={<Welcome/>}/>
            </Route>
            <Route path='/activities' element={<ProtectedRoute/>}>
              <Route index element={<><ActivitiesBar/><Activities/></>}/>
            </Route>

            <Route path='/administration' element={<ProtectedRoute/>}>
              <Route index element={<><ActivitiesBar/><Administration/></>}/>
            </Route>

            <Route path='/history' element={<ProtectedRoute/>}>
              <Route index element={<><ActivitiesBar/><History/></>}/>
            </Route>

            <Route path='/events' element={<ProtectedRoute/>}>
              <Route index element={<><ActivitiesBar/><Events/></>}/>
            </Route>

            <Route path='/profile' element={<ProtectedRoute/>}>
              <Route index element={<><ActivitiesBar/><Profile/></>}/>
            </Route>

            <Route path='/superadmin' element={<SuperAdminRoute/>}>
              <Route index element={<><ActivitiesBar/><SuperAdminDashboard/></>}/>
            </Route>

          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
